import { render, staticRenderFns } from "./ProductStatisticsDashboard.vue?vue&type=template&id=7d768d10&"
import script from "./ProductStatisticsDashboard.vue?vue&type=script&lang=js&"
export * from "./ProductStatisticsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports